import { ExpertRequestOrigin, ExpertRequestType, QueryResponseType } from '@/__generated__/graphql';
import { isAdvancedUser } from '@/core/group';

export function copyExpertRequest(viewer: any, expertRequest: any) {
  return {
    copy_from: expertRequest.id,
    name: `Copy of ${expertRequest.name}`,
    er_type: expertRequest.er_type,
    description: expertRequest.description,
    disclosure: isAdvancedUser(viewer) && expertRequest.unpaid ? expertRequest.disclosure : 'full',
    regions: expertRequest.regions,
    sectors: expertRequest.sectors,
    focus_areas: expertRequest.focus_areas,
    qualifications:
      expertRequest.qualifications && expertRequest.qualifications.length > 0
        ? expertRequest.qualifications.map((q: any) => ({
            query: q.query,
            response_type: q.response_type,
            required: q.required,
          }))
        : [{ query: '', response_type: QueryResponseType.YesNo }],
    questions:
      expertRequest.questions && expertRequest.questions.length > 0
        ? expertRequest.questions.map((q: any) => ({
            query: q.query,
            response_type: q.response_type,
            required: q.required,
          }))
        : [{ query: '', response_type: QueryResponseType.YesNo }],
    companies_avoid: expertRequest.companies_avoid || [],
    companies_pursue: expertRequest.companies_pursue || [],
    project_name: '',
    tracking_code: '',
    group_id: null,
    phone: expertRequest.phone,
    // ENG-5367: a copy is always a new, freshly-authored ER. Staff copying a
    // customer-authored ER must not mint another (locked) customer-authored one —
    // reset it to the staff default. cs/sales copies and customer copies are preserved.
    origin:
      viewer.admin && expertRequest.origin === ExpertRequestOrigin.CustomerAuthored
        ? ExpertRequestOrigin.CsAuthored
        : expertRequest.origin,
    sourcing_scope: expertRequest.sourcing_scope,
    allow_internal_vetting: expertRequest.allow_internal_vetting,
    allow_external_recruiting: expertRequest.allow_external_recruiting,
    project_id: expertRequest.project ? expertRequest.project.id : null,
    expertRequest: expertRequest.unpaid,
  };
}

export function getDefaultValues(viewer: any, initialProjectId: any) {
  const group = viewer.groups && viewer.groups.length === 1 && viewer.groups[0];

  return {
    attachments: [],
    name: '',
    description: '',
    disclosure: 'full',
    er_type: ExpertRequestType.Consultation,
    regions: [],
    sectors: [],
    focus_areas: [],
    qualifications: [{ query: '', response_type: QueryResponseType.YesNo }],
    questions: [{ query: '', response_type: QueryResponseType.YesNo }],
    companies_avoid: [],
    companies_pursue: [],
    project_name: '',
    tracking_code: '',
    group_id: group ? group.id : null,
    group_about: '',
    phone: viewer.admin ? '' : viewer.phone,
    skip_phone: viewer.admin,
    // ENG-5367: staff-created ERs default to CS-authored; customers (who never see
    // the origin control) keep customer-authored.
    origin: viewer.admin ? ExpertRequestOrigin.CsAuthored : ExpertRequestOrigin.CustomerAuthored,
    sourcing_scope: 'internal_plus_external',
    allow_internal_vetting: true,
    allow_external_recruiting: true,
    project_id: initialProjectId || null,
    unpaid: false,
    currentVisit: 1,
    formInitialized: false,
  };
}
